"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepsPayment = void 0;
const react_1 = __importDefault(require("react"));
const utils_1 = require("./utils");
require("./steps-payment.css");
;
;
;
/**
 * Main component.
 * @name stepsPayment
 * @param {StepsPaymentProps}
 * @returns {<StepsPayment />}
*/
const StepsPayment = ({ currentStep, style, steps }) => {
    return (react_1.default.createElement("div", { "data-testid": "stepspayment-element", className: "planssteps-container", style: { gridTemplateColumns: `repeat(${steps.length}, 1fr)` } }, (0, utils_1.utils)(currentStep, steps, style)));
};
exports.StepsPayment = StepsPayment;
//# sourceMappingURL=steps-payment.js.map